import { render, staticRenderFns } from "./UnidadesCard.vue?vue&type=template&id=d6fa36e8&scoped=true"
import script from "./UnidadesCard.vue?vue&type=script&lang=js"
export * from "./UnidadesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fa36e8",
  null
  
)

export default component.exports